import { useMemo } from 'react'
import { routes } from '../../routers/routers'
import { PermissionHelper } from '../../utils/helpers'

export default function usePermissionPage(
  pathname: string,
  user: { role: string; tenant: { enabledFeatures: string[] } }
) {
  const permittedPage = useMemo(() => {
    const currentRoute = routes?.find?.(route => route?.url === pathname)

    if (!currentRoute?.validations) {
      return true
    }

    return PermissionHelper.check(user?.tenant?.enabledFeatures, user?.role, currentRoute?.validations)
  }, [pathname])

  return [permittedPage] as const
}
